import React from 'react';
import { 
  Container,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
  Alert,
  AlertTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Divider 
} from '@mui/material';
import { Delete, Info } from '@mui/icons-material';

const AccountDeletion: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Card>
        <CardHeader
          title={
            <Box display="flex" alignItems="center" gap={1}>
              <Delete />
              <Typography variant="h5">
                Idya Hesap Silme Talebi
              </Typography>
            </Box>
          }
          subheader="Hesabınızı kalıcı olarak silme işlemi hakkında bilgilendirme"
        />
        <CardContent>
          <Alert severity="warning" sx={{ mb: 4 }}>
            <AlertTitle>Önemli Bilgilendirme</AlertTitle>
            Hesap silme işlemi geri alınamaz. Hesabınız silindikten sonra tüm verileriniz kalıcı olarak silinecektir.
          </Alert>

          <Typography variant="h6" gutterBottom>
            Hesap Silme Adımları
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>1.</ListItemIcon>
              <ListItemText primary="Idya uygulamasına giriş yapın" />
            </ListItem>
            <ListItem>
              <ListItemIcon>2.</ListItemIcon>
              <ListItemText primary="Profil bölümüne gidin" />
            </ListItem>
            <ListItem>
              <ListItemIcon>3.</ListItemIcon>
              <ListItemText primary="'Hesabı Sil' seçeneğine tıklayın" />
            </ListItem>
            <ListItem>
              <ListItemIcon>4.</ListItemIcon>
              <ListItemText primary="Silme işlemini onaylayın" />
            </ListItem>
          </List>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" gutterBottom>
            Veri Saklama Politikası
          </Typography>
          <Typography paragraph>
            Idya olarak, hesap silme işlemi sonrasında kullanıcı verilerini hiçbir şekilde saklamıyoruz.
            Hesabınızın silinmesi ile birlikte:
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon><Info /></ListItemIcon>
              <ListItemText primary="Kişisel bilgileriniz" />
            </ListItem>
            <ListItem>
              <ListItemIcon><Info /></ListItemIcon>
              <ListItemText primary="Hesap aktiviteleriniz" />
            </ListItem>
            <ListItem>
              <ListItemIcon><Info /></ListItemIcon>
              <ListItemText primary="Uygulama içi verileriniz" />
            </ListItem>
          </List>
          <Typography>
            kalıcı olarak silinmektedir.
          </Typography>

          <Paper sx={{ p: 2, bgcolor: 'grey.100', mt: 4 }}>
            <Typography variant="body2" color="text.secondary">
              Bu sayfa, Google Play Store politikaları gereğince hazırlanmıştır.
              Sorularınız için destek ekibimizle iletişime geçebilirsiniz.
            </Typography>
          </Paper>
        </CardContent>
      </Card>
    </Container>
  );
};

export default AccountDeletion;